<template>
  <div class="ttr">
    <div
      v-for="i in 5"
      class="ttr__ball"
      :class="{
        'ttr__ball--active': i - 1 === getGamesRejectedStreak,
        'ttr__ball--danger': i === 5,
      }"
    >
      <span class="ttr__ball-label">{{ i }}</span>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters(['getGamesRejectedStreak']),
    },
  };
</script>

<style scoped lang="scss">
  .ttr {
    &__ball {
      position: relative;
      vertical-align: middle;
      display: inline-block;
      margin: 4px;
      width: 42px;
      height: 42px;
      border-radius: 50%;
      background: #ffffff;
      background: url(../../assets/img/game/shadow-circle.png) center no-repeat;
      background-size: contain;

      &--danger {
        background-image: url(../../assets/img/game/shadow-circle-danger.png);
      }

      &::after {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        background: center no-repeat;
        background-size: contain;
        //
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        //
        transition: opacity 400ms;
        opacity: 0;
      }

      &--active::after {
        background-image: url(../../assets/img/game/chip.png);
        opacity: 1;
      }
    }

    &__ball-label {
      color: #ffffff;
      font-size: 20px;
      //
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
</style>
